<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
// import { initGoogleAPI } from './utils/googleAuth'
import { APP_DEFAULT_LOCALE } from './utils/const'
import { LANGUAGE_KEY } from './utils/localStorageKeys'

export default {
  mounted() {
    // Download selected language if needed on first mount
    const language = localStorage.getItem(LANGUAGE_KEY) || APP_DEFAULT_LOCALE
    this.setLanguage(language)

    // initGoogleAPI()
  },
  methods: {
    ...mapActions({
      setLanguage: 'app/setLanguage',
    }),
  },
}
</script>
